import * as React from 'react';
import { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';
import styled, { withTheme } from 'styled-components';
import { Table, TableBody, TableRow } from './Grid';
import DownloadControls from './DownloadControls';
import WatchListToggle from './WatchListToggle';
import DocumentDropDown from './DocumentDropDown';
import ChangeIndicator from './ChangeIndicator';
import { ShareclassColumn } from './ShareclassRows';
import Icon from './Icon';
import Translate from './Translate';

const FileDocumentIcon = styled(Icon)``;

FileDocumentIcon.defaultProps = {
    height: "1.4em",
    width: "1.4em"
};

@inject('dataStore')
@observer
class ShareclassColumnValue extends Component<any> {

    @computed
    get selectedGroupIndex() {
        return this.props.selectedGroupMap.get(this.props.columnIndex);
    }

    @computed
    get column() {
        return (this.props.column.groups) ? this.props.column.groups[this.selectedGroupIndex] : this.props.column;
    }

    render() {

        const { theme, dataStore, shareClass } = this.props;
        const { column } = this;

        if (["group", "dropdown"].includes(column.type)) {
            return (
                <Table>
                    <TableBody>
                        <TableRow>
                            {column.values.map((c, cIndex) =>
                                <ShareclassColumn
                                    key={`${column.type}-${c.value}-${cIndex}`}
                                    paddingX="sm"
                                    paddingY="0"
                                    textAlign={c.textAlign || 'center'}
                                    width={c.width}
                                >
                                    {
                                        c.multiple
                                            ?
                                            <Fragment>
                                                {
                                                    c.data.map((d, i) =>
                                                        <Fragment
                                                            key={i}
                                                        >
                                                            <Translate>{d.value}</Translate>{d.separator}
                                                            {
                                                                d.showChange &&
                                                                <ChangeIndicator value={d.value} />
                                                            }
                                                        </Fragment>
                                                    )
                                                }
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <Translate>{c.data.value}</Translate>
                                                {
                                                    c.data.showChange &&
                                                    <ChangeIndicator value={c.data.value} />
                                                }
                                            </Fragment>
                                    }
                                </ShareclassColumn>
                            )}
                        </TableRow>
                    </TableBody>
                </Table>
            );
        }

        if (column.type === "download") {
            return (
                <DownloadControls
                    count={shareClass.downloadCount}
                    display="inline-flex"
                    theme={{
                        ...theme,
                        ...{
                            DownloadButton: theme.ShareclassRowDownloadButton,
                            DownloadCount: theme.ShareclassRowDownloadCount
                        }
                    }}
                    onClick={e => { e.stopPropagation(); dataStore.downloadDocuments(shareClass.shareClassDownloads); }}
                />
            );
        }

        if (column.type === "watchlist" && dataStore.watchListEnabled) {
            return (
                <WatchListToggle
                    onClick={e => { e.stopPropagation(); shareClass.toggleWatchList(); }}
                    active={shareClass.inWatchList}
                />
            );
        }

        if (column.type === "document") {
            return (
                <Fragment>
                    {
                        column.value.length ?
                            <DocumentDropDown
                                documents={column.value}
                                documentSelected={shareClass.documentSelected}
                                toggleDownload={shareClass.toggleDownload}
                            >
                                <FileDocumentIcon
                                    fileName="DocumentIcon"
                                />
                            </DocumentDropDown>
                            : <Translate>{dataStore.config.noDataPlaceholder}</Translate>
                    }
                </Fragment>
            );
        }

        if (column.type === "prices") {
            return (
                <DownloadControls
                    display="inline-flex"
                    onClick={e => { e.stopPropagation(); shareClass.getPriceHistory(column); }}
                    count={1}
                    showCount={false}
                />
            );
        }

        if (column.multiple) {
            return (
                <Fragment>
                    {
                        column.data.map((d, i) =>
                            <Fragment
                                key={i}
                            >
                                <Translate>{d.value}</Translate>{d.separator}
                                {
                                    d.showChange &&
                                    <ChangeIndicator value={d.value} />
                                }
                            </Fragment>
                        )
                    }
                </Fragment>
            );
        }

        return (
            <Fragment>
                <Translate>{column.data.value}</Translate>
                {
                    column.data.showChange &&
                    <ChangeIndicator value={column.data.value} />
                }
            </Fragment>
        );
    }
}

export default withTheme(ShareclassColumnValue) as any;


// WEBPACK FOOTER //
// ./src/Components/ShareclassColumnValue.tsx